import { FC, PropsWithChildren } from 'react';

import classNames from 'classnames';
import { Pencil, Trash2 } from 'lucide-react';

import { Box, IconButton, Tooltip, Typography } from '@mui/material';

import css from './ActionsCard.module.css';

import { Popconfirm } from 'v2/components/popconfirm/Popconfirm';

export interface ActionsCardProps {
  label: string;
  openEditModal: () => void;
  openDeleteModal: () => void;
  extraActionsCardContainer?: string;
  deleteConfirmationMessage?: string;
  size?: 'default' | 'compact';
}

export const ActionsCard: FC<PropsWithChildren<ActionsCardProps>> = ({
  label,
  openEditModal,
  openDeleteModal,
  children,
  extraActionsCardContainer,
  deleteConfirmationMessage,
  size = 'default',
}) => {
  const isCompact = size === 'compact';
  const iconSize = isCompact ? 14 : 18;

  return (
    <Box
      className={classNames(
        css.actionsCardContainer,
        isCompact && css.actionsCardCompact,
        extraActionsCardContainer ? undefined : css.actionsCardDefaultBackground,
        extraActionsCardContainer
      )}
    >
      <Tooltip title={label}>
        <Typography className={css.actionsCardLabel}>{label}</Typography>
      </Tooltip>
      {children}
      <div className={css.actionsCardActions}>
        <Tooltip title="Edit" placement="top">
          <IconButton className={css.actionsCardActionButton} onClick={openEditModal}>
            <Pencil width={iconSize} height={iconSize} />
          </IconButton>
        </Tooltip>

        {deleteConfirmationMessage ? (
          <Popconfirm message={deleteConfirmationMessage} onConfirm={openDeleteModal}>
            <Tooltip title="Delete" placement="top">
              <IconButton className={css.actionsCardActionButton}>
                <Trash2 width={iconSize} height={iconSize} />
              </IconButton>
            </Tooltip>
          </Popconfirm>
        ) : (
          <Tooltip title="Delete" placement="top">
            <IconButton className={css.actionsCardActionButton} onClick={openDeleteModal}>
              <Trash2 width={iconSize} height={iconSize} />
            </IconButton>
          </Tooltip>
        )}
      </div>
    </Box>
  );
};
